// extracted by mini-css-extract-plugin
export default {"wishlist_container":"wishListStyle_wishlist_container__FBs-m"};